export type UserAuthType = 0 | 1 | 2;

export const UserAuthType = {
  None: 0 as const,
  ApiKeyInput: 1 as const,
  OAuth2Login: 2 as const,
};

export default UserAuthType;
